import * as React from "react";
import { render } from "react-dom";
import { LiquidAccount } from "../../types";
import * as Loyalty from "@dotdev/reactive-rewards";

const CartTemplate: React.FC = () => {
  const [account, setAccount] = React.useState<LiquidAccount>(null);

  React.useEffect(() => {
    (async () => {
      const res = await fetch(`/account?view=json`);
      const text = await res.text();
      const json = JSON.parse(text.replace(/(<([^>]+)>)/gi, ""));
      setAccount(json);
    })();
  }, []);

  if (!account) {
    return (
      <p>
        Please{" "}
        <a href="/account/login" className={`font-bold`}>
          Login
        </a>{" "}
        or{" "}
        <a href="/account/register" className={`font-bold`}>
          Register
        </a>{" "}
        to join the Cable Collective and earn rewards from your purchase.
      </p>
    );
  }

  return (
    <div>
      <Loyalty.Provider
        customer={account.customer}
        rewardId={window.theme.rewardId}
        url={window.theme.loyaltyUrl}
        storefront={{
          key: window.theme.storeFrontKey,
          url: window.theme.permanentDomain
        }}
      >
        <Loyalty.Benefits title={"Gifts & Rewards"} redeemable />
      </Loyalty.Provider>
    </div>
  );
};

window.addEventListener("load", () => {
  const cartContainer = document.getElementById("CartTemplate");
  if (cartContainer) {
    render(<CartTemplate />, cartContainer);
  }
});

document.addEventListener("theme:loading:end", e => {
  if (window.theme.template === "cart") {
    window.location.reload();
  }
});
